import { LineChart, BarChart, ChartContainer } from '../../../components/Charts';
import dayjs from 'dayjs';
import { useState, useEffect } from 'react';

const ChargerChart = ({
  isLoading,
  error,
  chargingHistoryTimeSlot,
  periodChargerStatTwoWeeks,
  periodChargerStatOneYear,
}) => {
  const today = dayjs().format('YYYY-MM-DD');
  const twoWeeksAgo = dayjs().subtract(14, 'day').format('YYYY-MM-DD');
  const oneMonthAgo = dayjs().subtract(1, 'month').format('YYYY-MM');
  const oneYearAgo = dayjs().subtract(12, 'month').format('YYYY-MM');
  const yesterday = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
  const [cssColors, setCssColors] = useState({
    graphSetZ1: '#8C62FF',
    graphSetZ2: '#FB85A1',
    graphSetZ3: '#38BDF8',
    graphSetZ4: '#FEC02E',
  });

  useEffect(() => {
    const getCSSVariable = (variable) => {
      return getComputedStyle(document.documentElement)
        .getPropertyValue(variable)
        .trim();
    };
    setCssColors({
      graphSetZ1: getCSSVariable('--graph-set-z1'),
      graphSetZ2: getCSSVariable('--graph-set-z2'),
      graphSetZ3: getCSSVariable('--graph-set-z3'),
      graphSetZ4: getCSSVariable('--graph-set-z4'),
    });
  }, []);

  return (
    <>
      <div className='flex flex-col gap-10 mb-20'>
        <h3 className='text-b1-700 text-base'>충전기 과거 24시간 충전 이력</h3>
        <p className='text-b2-700 text-gray-600'>집계 기준 : {yesterday} 00:00 ~ 23:59</p>
        <ChartContainer
          isLoading={isLoading}
          error={error}
          hasData={chargingHistoryTimeSlot && chargingHistoryTimeSlot.length > 0}
          loadingText="충전 이력을 불러오는 중..."
          errorText="충전 이력을 불러오는데 실패했습니다"
          // noDataText="충전 이력 데이터가 없습니다"
          height="300px"
        >
          <LineChart
            data={{
              labels: chargingHistoryTimeSlot?.map(item => {
                let time = item.SlotStartTime?.split('T')[1];
                time = time.split(':');
                time = time[0] + ':' + time[1];
                return time;
              }) || [],
              datasets: [
                {
                  label: '충전 이력',
                  data: chargingHistoryTimeSlot?.map(item => item.AoC/1000) || [],
                  borderColor: cssColors.graphSetZ3,
                  backgroundColor: cssColors.graphSetZ3,
                  fill: false,
                  tension: 0.1
                }
              ]
            }}
            title="24시간 전력 수요 추이"
            height="280px"
            yMin={0}
          />
        </ChartContainer>
      </div>
      <div className='flex flex-col gap-10 mb-20'>
        <h3 className='text-b1-700 text-base'>충전기 과거 2주 통계</h3>
        <p className='text-b2-700 text-gray-600'>집계 기준 : {twoWeeksAgo} ~ {yesterday} </p>
        <ChartContainer
          isLoading={isLoading}
          error={error}
          hasData={periodChargerStatTwoWeeks && periodChargerStatTwoWeeks.length > 0}
          loadingText="충전 이력을 불러오는 중..."
          errorText="충전 이력을 불러오는데 실패했습니다"
          // noDataText="충전 이력 데이터가 없습니다"
          height="300px"
        >
          <BarChart
            data={{
              labels: periodChargerStatTwoWeeks?.map(item => {
                let time = item.Date?.split('T')[0];
                return time;
              }) || [],
              datasets: [
                {
                  label: '전력량 (kWh)',
                  data: periodChargerStatTwoWeeks?.map(item => (item.TotalAoC/1000).toFixed(2)) || [],
                  borderColor: cssColors.graphSetZ3,
                  backgroundColor: cssColors.graphSetZ3,
                  fill: false,
                  tension: 0.1
                },
                {
                  label: '충전횟수',
                  data: periodChargerStatTwoWeeks?.map(item => item.TotalChargingCount) || [],
                  borderColor: cssColors.graphSetZ4,
                  backgroundColor: cssColors.graphSetZ4,
                  fill: false,
                  tension: 0.1
                },
                {
                  label: '충전시간 (시간)',
                  data: periodChargerStatTwoWeeks?.map(item => (item.TotalChargingSeconds/60).toFixed(2)) || [],
                  borderColor: cssColors.graphSetZ1,
                  backgroundColor: cssColors.graphSetZ1,
                  fill: false,
                  tension: 0.1
                }
              ]
            }}
            title="24시간 전력 수요 추이"
            height="280px"
            maxTicksLimit={14}
            yMin={0}
          />
        </ChartContainer>
      </div>
      <div className='flex flex-col gap-10 mb-20'>
        <h3 className='text-b1-700 text-base'>충전기 과거 1년 통계</h3>
        <p className='text-b2-700 text-gray-600'>집계 기준 : {oneYearAgo} ~ {oneMonthAgo} </p>
        <ChartContainer
          isLoading={isLoading}
          error={error}
          hasData={periodChargerStatOneYear && periodChargerStatOneYear.length > 0}
          loadingText="충전 이력을 불러오는 중..."
          errorText="충전 이력을 불러오는데 실패했습니다"
          // noDataText="충전 이력 데이터가 없습니다"
          height="300px"
        >
          <BarChart
            data={{
              labels: periodChargerStatOneYear?.map(item => {
                let time = item.Date?.split('T')[0];
                let yearMonth = time.split('-')[0] + '-' + time.split('-')[1];
                return yearMonth;
              }) || [],
              datasets: [
                {
                  label: '전력량 (kWh)',
                  data: periodChargerStatOneYear?.map(item => (item.TotalAoC/1000).toFixed(2)) || [],
                  borderColor: cssColors.graphSetZ3,
                  backgroundColor: cssColors.graphSetZ3,
                  fill: false,
                  tension: 0.1
                },
                {
                  label: '충전횟수',
                  data: periodChargerStatOneYear?.map(item => item.TotalChargingCount) || [],
                  borderColor: cssColors.graphSetZ4,
                  backgroundColor: cssColors.graphSetZ4,
                  fill: false,
                  tension: 0.1
                },
                {
                  label: '충전시간 (분)',
                  data: periodChargerStatOneYear?.map(item => (item.TotalChargingSeconds/60).toFixed(2)) || [],
                  borderColor: cssColors.graphSetZ1,
                  backgroundColor: cssColors.graphSetZ1,
                  fill: false,
                  tension: 0.1
                }
              ]
            }}
            title="24시간 전력 수요 추이"
            height="280px"
            maxTicksLimit={12}
            yMin={0}
          />
        </ChartContainer>
      </div>
    </>
  )
}

export default ChargerChart